<template lang="html">
  <footer>
      <div class="flexbox">
        <div>
          <img src="@/assets/footer-logo.png">
          <h2 class="fs25">佛山(潭洲)国际陶瓷展</h2>
          <div class="fs16 mt15">UNICERAMICS EXPO</div>
          <div class="fs16 mt12">2023/4/18-22</div>
          <div class="fs16 mt12">佛山（潭洲）国际会展中心</div>
          <div class="link mt35">
            <router-link to="/about">{{$t('footer.about')}}</router-link>
            <span>/</span>
            <router-link to="/contact">{{$t('footer.contact')}}</router-link>
          </div>
        </div>
        <div class="qrcode-box" v-if="lang==='zh'">
          <div class="qrcode">
            <img src="@/assets/qrcode.jpg" :alt="$t('footer.weixin')">
            <div class="fs16 mt10">{{$t('footer.video')}}</div>
          </div>
          <div class="qrcode" style="margin-left:1vw;">
            <img src="@/assets/qrcode-wx.jpg" :alt="$t('footer.weixin')">
            <div class="fs16 mt10">{{$t('footer.weixin')}}</div>
          </div>
        </div>
        <div class="qrcode-box en" v-if="lang==='en'">
          <div class="qrcode">
            <a href="https://www.youtube.com/channel/UCgi2YVLOq-AozPhA2zOmoEw" target="_bland">
            <img src="@/assets/youtube.jpg" />
            <div class="fs14 mt10">YouTube</div>
            </a>
          </div>
          <!-- <div class="qrcode" style="margin-left:1vw;">
            <a href="https://www.facebook.com/Uniceramics-Expo-102021165285660/" target="_bland">
              <img src="@/assets/facebok.png" />
              <div class="fs14 mt10">Facebook</div>
             </a>
          </div> -->
          <div class="qrcode" style="margin-left:1vw;">
            <a href="https://twitter.com/CicpeChina" target="_bland">
              <img src="@/assets/twitter.png" />
              <div class="fs14 mt10">Twitter</div>
             </a>
          </div>
          <div class="qrcode" style="margin-left:1vw;">
            <a href="https://www.instagram.com/uniceramics_expo/" target="_bland">
              <img src="@/assets/ins.png" />
              <div class="fs14 mt10">Instagram</div>
             </a>
          </div>
        </div>

        

      </div>
      <div class="center mt60 pc">
        Uniceramics Expo <a target="_bland" href="https://beian.miit.gov.cn/">粤ICP备20006720号</a>
        <span>佛山陶联科技发展有限公司</span>
      </div>
      <!-- <div class="mobile-footer">
        <img src="@/assets/footer.jpg" />
      </div> -->
  </footer>
</template>

<script>
export default {
    name:'footer',
    data() {
        return {}
    },
    computed:{
      lang(){return this.$store.state.index.lang}
    },
}
</script>

<style scoped>
footer{box-sizing:border-box; height:17vw; padding:3.2vw 6.3vw 3.5vw 6.3vw; background: #e70031; color:#fff; }
footer .flexbox{display:flex; justify-content: space-between;}
footer .flexbox>div:nth-of-type(1){padding-left:8.42vw; position: relative;}
footer .flexbox>div:nth-of-type(1) img{width:7.895vw; height:7.368vw; position:absolute; top:0; left:0;}
footer .flexbox>div:nth-of-type(1) .mt12{margin-top:0.65vw;}
footer .flexbox>div:nth-of-type(1) .link>span{margin:0 0.8vw;}
footer .flexbox>div:nth-of-type(1) .link>a:hover{text-decoration: underline;}

footer .flexbox>div.qrcode-box{display:flex;}
footer .flexbox>div.qrcode-box.en .qrcode{width:7vw;}
footer .flexbox>div:nth-of-type(2){text-align:center;}
footer .flexbox>div:nth-of-type(2) img{width:6.4vw; height:6.4vw;}
footer>.center{text-align:center; color:#fbbebb;}
footer .mobile-footer{display:none;}
footer>.center>span{margin-left:5px;}
footer>.center>a{text-decoration: underline;}
footer>.center>a:hover{color:blue;}
@media (max-width: 991px){

footer{height:32vw; padding:6.9vw 2.3vw 3.5vw 2.3vw;}
footer .flexbox>div.qrcode-box.en .qrcode{width:15vw;}
footer .flexbox>div:nth-of-type(1){padding-left:0;}
footer .flexbox>div:nth-of-type(1) img{display:none;}
footer .flexbox>div:nth-of-type(1) .mt12{margin-top:1.8vw;}
footer .flexbox>div:nth-of-type(1) .link{margin-top:4vw;}
footer .flexbox>div:nth-of-type(2) img{width:13.5vw; height:13.5vw;}
footer>.center{margin-top:5vw;}
footer>.center>span{margin-left:10px;}

/*footer {height:auto; padding:0; background:none; font-size:0;}
footer .pc{display:none;}
footer .mobile-footer{display:block;}
footer .mobile-footer img{width:100%;}*/

}
</style>

